export class HttpError<TBody = string> extends Error {
  public statusCode: number;
  public statusText: string;
  public body: TBody;

  constructor(statusCode: number, statusText: string, body: TBody) {
    super(`HTTP ${statusCode} ${statusText}: ${JSON.stringify(body)}`);
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = 'HttpError';
    this.statusCode = statusCode;
    this.statusText = statusText;
    this.body = body;
  }
}
